/**
 * Attaches persisted attribution data to the Shopify cart
 * using cart attributes so it is preserved through checkout.
 */

var AttributionCart = (function () {
  'use strict';

  var ATTR_DEBUG = false;

  var DIFF_IGNORE_KEYS = {
    attr_consent_meta_json: true
  };

  function log() {
    if (ATTR_DEBUG) console.log.apply(console, arguments);
  }

  function buildAttributes(data) {
    log("using data this to append",data);
    var first = data.first_touch || {};
    var last = data.last_touch || {};
    var consent = data.consentMeta || {};

    var firstRaw = data.first_touch_raw_params || {};
    var lastRaw = data.last_touch_raw_params || {};

    return {
      // IDs
      lmj_user_id: data.lmj_user_id || '',
      lmj_session_id: data.lmj_session_id || '',

      // LANDINGS
      attr_user_first_landing_url: data.user_first_landing_url || '',
      attr_session_entry_url: data.session_entry_url || '',
      attr_session_entry_referrer_external: data.session_entry_referrer_external || '',

      session_last_activity_at: data.session_last_activity_at || '',

      // CONSENT META
      attr_consent_status: consent.status || '',
      attr_consent_timestamp: consent.timestamp || '',
      attr_consent_meta_json: consent ? JSON.stringify(consent) : '',

      // FIRST TOUCH
      attr_first_touch_source: first.utm_source || '',
      attr_first_touch_medium: first.utm_medium || '',
      attr_first_touch_campaign: first.utm_campaign || '',
      attr_first_touch_content: first.utm_content || '',
      attr_first_touch_term: first.utm_term || '',
      attr_first_touch_gclid: first.gclid || '',
      attr_first_touch_gbraid: first.gbraid || '',
      attr_first_touch_wbraid: first.wbraid || '',

      // LAST TOUCH
      attr_last_touch_source: last.utm_source || '',
      attr_last_touch_medium: last.utm_medium || '',
      attr_last_touch_campaign: last.utm_campaign || '',
      attr_last_touch_content: last.utm_content || '',
      attr_last_touch_term: last.utm_term || '',
      attr_last_touch_gclid: last.gclid || '',
      attr_last_touch_gbraid: last.gbraid || '',
      attr_last_touch_wbraid: last.wbraid || '',

      // RAW PARAMS
      attr_first_touch_raw_params: JSON.stringify(firstRaw),
      attr_last_touch_raw_params: JSON.stringify(lastRaw),

      // METADATA
      attr_device_type: data.device?.device_type || '',
      attr_browser_family: data.device?.browser_family || '',
      attr_os_family: data.device?.os_family || ''
    };
  }

  function shallowEqual(a, b) {
    var keys = Object.keys(a);

    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];

      if (DIFF_IGNORE_KEYS[k]) continue;

      if ((a[k] || '') !== (b[k] || '')) {
        return false;
      }
    }

    return true;
  }

  function attachToCart() {
    log('[Attribution][Cart] Checking cart for existing attribution');

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var data = AttributionStorage.read();
        if (!data) {
          log('[Attribution][Cart] No persisted data found, skipping');
          return;
        }

        var nextAttrs = buildAttributes(data);
        var currentAttrs = cart.attributes || {};

        if (shallowEqual(nextAttrs, currentAttrs)) {
          log('[Attribution][Cart] Attributes unchanged, skipping update');
          return;
        }

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: nextAttrs })
        });
      })
      .then(function () {
        log('[Attribution][Cart] Attribution successfully attached');
      })
      .catch(function (err) {
        log('[Attribution][Cart] Cart update failed', err);
      });
  }

  return {
    attachToCart: attachToCart
  };

})();
